import { IS_DEV } from '../../app/utils';

export const SUB_DOMAIN = 'payment';

export const getAPIBaseUrl = (subDomain = SUB_DOMAIN) => {
  const [, ...domain] = window.location.hostname.split('.');

  return [subDomain, 'api', ...domain].join('.');
};

const getHTTPUrl = () => {
  if (IS_DEV) {
    return process.env['NX_GRAPHQL_API_DEV'] || '';
  }

  return `https://${getAPIBaseUrl()}`;
};

const getWsUrl = () => {
  if (IS_DEV) {
    return process.env['NX_GRAPHQL_WS_API_DEV'] || '';
  }

  return `wss://${getAPIBaseUrl()}/gql`;
};

const getMerchantAPIUrl = () => {
  if (IS_DEV) {
    return 'https://merchants.api.dev.crypto.xmoney.com/api';
  }

  return `https://${getAPIBaseUrl('merchants')}/api`;
};

export { getHTTPUrl, getWsUrl, getMerchantAPIUrl, IS_DEV };
